const colors = {
  'ultramarine-blue': '#1727CA',
  'mint-green': '#B3E575',
  'sunset-orange': '#F79030',
  'summer-yellow': '#F7BF30',
  'soft-green': '#EAFAE4',
  'onyx': '#08070B',
  'slate-grey': '#AAACB5',
  'misty-grey': '#D7DAE2',
  'arctic-grey': '#EEF1F9'
}

export default colors



// WEBPACK FOOTER //
// ./src/plugins/colors.js